﻿
import './style.scss';
import Vue from 'vue';

var basePath = window.app.base;
var instance = new Vue({
    data: {
        searchString: "",
        results: [],
        error: false,
        loading: false,
        requests: []
    },
    methods: {

        // opens the modal
        open: function () {
            var el = $("#search-component");
            $(el).modal('show');
            $(el).find('input').trigger('focus');
        },

        makeRequest: function (q) {
            var c = this;

            var xhr = $.ajax({
                url: basePath+"Home/SearchAutoComplete?q=" + q.replace("%", "%25"),
                method: "GET"
            });

            var req = {
                xhr: xhr,
                time: new Date()
            };
            c.requests.push(req);

            return req;
        },
 
        isLatestRequest: function(req) {
            var c = this;

            var latest = true;
            for (var i = 0; i < c.requests.length; i++) {
                if (req.time < c.requests[i].time) {
                    latest = false;
                }
            }

            return latest;
        },

        // loads data from server
        onValueChanged: function() {
            var c = this;

            c.error = false;
            c.loading = true;
            var q = c.searchString;
            
            if (q.length >= 2) {

                var req = c.makeRequest(q);
                req.xhr.done(function (jsonResult) {
                    if (c.isLatestRequest(req)) {
                        //var categories = jsonResult;
                        c.results = jsonResult;
                        c.loading = false;
                    }
                }).fail(function (partialRes) {
                    if (c.isLatestRequest(req)) {
                        c.results = [];
                        c.error = true;
                        c.loading = false;
                    }
                });
                
            } else {
                this.results = [];
                c.loading = false;
            }
        },

        openItem: function(item) {
            var id = item.Id;

            var url = basePath +"Komitent/Details/" + id;
        
            window.location.href = url;
        }
    }
});

window.openSearch = function() {
    instance.open();
};


var component = {
    v: instance,
    name: "search-component"
};

//window.app.components.search = instance;

export default component;